import {
  styled,
} from '@volkswagen-onehub/components-core';


export const StyledCTAGroup = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.background.secondary};
  border-radius: ${theme.size.static500};
  flex-grow: 0;
`
);
